/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-10 17:21:22
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-05-27 15:55:18
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Uploader/Uploader.tsx
 */
import { validateUploadingFiles } from '@/src/tools/validate';
import { modal } from '@/src/utils/Modal';
import { Upload } from 'antd';
import lodash from 'lodash';
import React from 'react';
import { getBaseUrl } from 'src/tools/server';
import css from './css.less';
import { generatorAuth } from 'src/tools/helper';

const CustomUploader = (props) => {
  const {
    drag,
    showUploadList,
    children,
    fileList,
    className,
    multiple,
    setLoading,
    setLoadingPercentage,
    onChange,
    onChangeStatus,
    accept,
    disabled,
  } = props;
  const auth = generatorAuth();
  const Component = drag ? Upload.Dragger : Upload;
  const uploader = React.useCallback(() => {
    return {
      name: 'file',
      accept: accept || 'image/*',
      disabled,
      action: `${getBaseUrl()}portal/mediaLibrary/upload`,
      // 'https://dev-server=.unifyxp.com/image/upload/Category?cid=1d56ded1-dcd5-4819-87b5-f3a71be897ca&token=bb8e94a1-2137-4019-92fe-bbf436f8d1b5&referenceUuid=8028743f-f70d-45ec-9a5f-8fa190ab7105&locale=en-US',
      headers: { Accept: 'application/json', Authorization: auth },
      beforeUpload(file) {
        const errors = validateUploadingFiles(file);
        if (errors.length !== 0) {
          modal.error({
            title: errors[0],
            content: 'Please check your file to make sure this file is valid',
            onOkText: 'OK',
            onOk: () => {
              console.log('ok');
            },
          });
          return Promise.reject();
        } else {
          if (setLoading) setLoading(true);
          if (setLoadingPercentage) setLoadingPercentage(0);
          return true;
        }
      },
      data(file) {
        return {
          originalName: file.name,
        };
      },
      onChange(info) {
        console.log(info, 'info');
        if (onChangeStatus) {
          onChangeStatus(info);
        }
        const fileList = [...info.fileList];

        const { status } = info.file;
        // 2. Read from response and show file link
        if (info.event) {
          if (setLoadingPercentage)
            setLoadingPercentage(Math.round(info.event.percent));
        }
        if (status === 'done') {
          const res = fileList.map((file) => {
            if (file.response) {
              const { payload } = file.response;
              const { url, uuid } = payload || {};
              return {
                ...payload,
                //name: file.name,
                originalName: file.name,
                url: url,
                size: file.size,
                status: file.status,
                uuid: uuid,
                uid: uuid,
              };
            } else return file;
          });

          if (setLoading) setLoading(false);
          if (setLoadingPercentage) setLoadingPercentage(Math.round(0));

          if (onChange) onChange(res);
        }
        if (status === 'error') {
          const errorDesc = lodash.get(info, 'file.response.payload.errorDesc');
          modal.forceError({
            title: 'Upload Error',
            content: errorDesc || 'System Error, Please Contact Admin',
            onOk: () => {
              console.log('Ok');
            },
            onOkText: 'OK',
          });
          if (setLoading) setLoading(false);
          if (setLoadingPercentage) setLoadingPercentage(Math.round(0));
        }

        // that.setState({ fileList }, () => {
        //   if (onChangeEvent) onChangeEvent(info);
        //   if (returnResult) returnResult(fileList);
        // });
      },
    };
  }, [accept]);

  return (
    <Component
      multiple={multiple}
      {...uploader()}
      fileList={fileList || []}
      className={className || ''}
      showUploadList={showUploadList}>
      {children}
    </Component>
  );
};

const _Upload = (props) => {
  const { children, ...rest } = props;
  return (
    <div className={css.uploadContainer}>
      <Upload {...rest}>{children}</Upload>
    </div>
  );
};
export { _Upload as Upload };
export default CustomUploader;
